export default __webpack_public_path__ + "static/media/logo_3.54f3bcd8.png";